import { levelSchema } from './level.schema';
import { levelRuleset } from './level.ruleset';
import { levelModifiers } from './level.modifiers';
import { levelActions } from './level.actions';
import { Inventory } from '../inventory';
import { ReplicantModuleState } from '../../utils';
import { Immutable } from '@play-co/replicant';

export type Level = typeof Level;
// eslint-disable-next-line no-redeclare
export namespace Level {
  export const $DEPENDENCIES = { Inventory };

  export const schema = levelSchema;
  export const ruleset = levelRuleset;
  export const modifiers = levelModifiers(Level);
  export const actions = levelActions(Level, $DEPENDENCIES);

  export type MutableState = ReplicantModuleState<Level>;
  export type State = Immutable<MutableState>;
}
